/**
 * Tour específico para la página del dashboard
 */
export const getDashboardTour = (theme) => {
  return [
    {
      element: '.dashboard-stats',
      popover: {
        title: 'Estadísticas Principales',
        description: 'Resumen de métricas clave de tu operación diaria.',
        position: 'bottom'
      }
    },
    {
      element: '.dashboard-charts',
      popover: {
        title: 'Gráficos y Tendencias',
        description: 'Visualización de datos históricos y tendencias de rendimiento.',
        position: 'top'
      }
    },
    {
      element: '.dashboard-recent-activity',
      popover: {
        title: 'Actividad Reciente',
        description: 'Últimas operaciones y eventos importantes registrados en el sistema.',
        position: 'left'
      }
    }
  ];
};